import { PartialActionDispatch, ResponseDispatch, StateObj } from 'src/types'

export const first = (array: StateObj[]): StateObj => array[0]
export const objectsFilter = (selected: string, objects: StateObj[]): StateObj => first(objects.filter((x) => x.value === selected))

export const useOriginDispatcher = (DISPATCHER: any, key: string, dispatch: PartialActionDispatch, stateObjects: StateObj[]): ResponseDispatch => {
  return (selected: string) => {
    dispatch({
      type: DISPATCHER[key],
      [key]: objectsFilter(selected, stateObjects)
    })
  }
}
